import React from 'react';
import Navbar from 'containers/Navbar.container';
import Footer from 'containers/Footer.container';

export default ({ children }) => {
  return (
    <div>
      <Navbar />
      <div className="content">
        {children}
      </div>
      <Footer />
    </div>
  );
};


// WEBPACK FOOTER //
// ./src/components/Layout.js